import { render, staticRenderFns } from "./FooterComponentT4a.vue?vue&type=template&id=164e27d4&scoped=true"
import script from "./FooterComponentT4a.vue?vue&type=script&lang=ts"
export * from "./FooterComponentT4a.vue?vue&type=script&lang=ts"
import style0 from "./FooterComponentT4a.vue?vue&type=style&index=0&id=164e27d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164e27d4",
  null
  
)

export default component.exports